import { render, staticRenderFns } from "./MyPOLVote.vue?vue&type=template&id=1a40da74&"
import script from "./MyPOLVote.vue?vue&type=script&lang=js&"
export * from "./MyPOLVote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports